import React from 'react';
import type ProjectSettingsServiceDeskAutomationSummaryType from '@atlassian/jira-spa-apps-project-settings-service-desk-automation-summary/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskAutomationSummary = lazyForPaint<
	typeof ProjectSettingsServiceDeskAutomationSummaryType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-automation-summary", jiraSpaEntry: "async-project-settings-service-desk-automation-summary" */ '@atlassian/jira-spa-apps-project-settings-service-desk-automation-summary'
		),
);

const AsyncProjectSettingsServiceDeskAutomationSummary = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskAutomationSummary}
		pageId="project-settings-automation-summary"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskAutomationSummary;
